export function Ratio5x4Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="1.875" y="16.25" width="12.5" height="16.25" rx="2" transform="rotate(-90 1.875 16.25)" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio5x4Icon.displayName = 'Ratio5x4Icon';
